import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { ModalHeader, ModalStyled } from "./Modal.styled";

export interface ModalI {
  open: boolean;
  handleClose?: () => void;
}
const Transition: any = React.forwardRef<unknown, any>((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

export const Modal: React.FC<ModalI> = ({
  open = false,
  handleClose,
  children,
}) => {
  return (
    <ModalStyled
      fullScreen
      TransitionComponent={Transition}
      open={open}
      onClose={handleClose}
    >
      <ModalHeader onClick={handleClose}>
        <CloseIcon />
      </ModalHeader>
      {children}
    </ModalStyled>
  );
};
